import * as THREE from 'three'
import Experience from '../Experience.js'
import { Float32Attribute, MathUtils } from 'three'

export default class SegmentSix
{
    constructor()
    {
        this.experience = new Experience();
        this.scene = this.experience.scene;
        this.resources = this.experience.resources;
        this.time = this.experience.time;        
        this.increment = 20;
        this.resourceA = this.resources.items.segmentModel6A;
        this.resourceB = this.resources.items.segmentModel6B;
        this.tags = {}
        this.setTextures();
        this.setMaterial();
        this.setModel();
    }

    setTextures()
    {
        this.textures = {}
        this.textures.building1 = this.resources.items.s6ATexture;
        this.textures.building1.flipY = false;
        this.textures.building2 = this.resources.items.s6BTexture;
        this.textures.building2.flipY = false;
        this.textures.building3 = this.resources.items.s6CTexture;
        this.textures.building3.flipY = false;
        this.textures.plants = this.resources.items.s6GTexture;
        this.textures.plants.flipY = false;
        this.textures.computers = this.resources.items.s6ETexture;
        this.textures.computers.flipY = false;
        this.textures.clouds = this.resources.items.s6DTexture;
        this.textures.clouds.flipY = false;
        this.textures.world = this.resources.items.s6ITexture;
        this.textures.world.flipY = false;
        this.textures.doors = this.resources.items.s6FTexture;
        this.textures.doors.flipY = false;
        this.textures.raks = this.resources.items.s6HTexture;
        this.textures.raks.flipY = false;
    }

    setMaterial()
    {
        this.building1Material = new THREE.MeshBasicMaterial({
            map: this.textures.building1
        })
        this.building2Material = new THREE.MeshBasicMaterial({
            map: this.textures.building2
        })
        this.building3Material = new THREE.MeshBasicMaterial({
            map: this.textures.building3
        })
        this.plantsMaterial = new THREE.MeshBasicMaterial({
            map: this.textures.plants
        })
        this.computersMaterial = new THREE.MeshBasicMaterial({
            map: this.textures.computers
        })
        this.cloudsMaterial = new THREE.MeshBasicMaterial({
            map: this.textures.clouds
        })
        this.worldMaterial = new THREE.MeshBasicMaterial({
            map: this.textures.world
        })
        this.doorsMaterial = new THREE.MeshBasicMaterial({
            map: this.textures.doors
        })
        this.racksMaterial = new THREE.MeshBasicMaterial({
            map: this.textures.raks
        })
        this.sectorMaterial = new THREE.MeshBasicMaterial();
        this.sectorMaterial.opacity = 0; 
        this.sectorMaterial.transparent = true;
    }

    setModel(index)
    {
        this.modelA = this.resourceA.scene.clone(true);
        this.modelB = this.resourceB.scene.clone(true);
        
        this.modelA.traverse((child)=>
        {                
            switch(child.name)
            {
               case "Building2":
                    child.material = this.building2Material;
                    break;   
               case "Building1":
                    child.material = this.building1Material;
                    break; 
                case "Building_3":
                    child.material = this.building3Material;
                    break;   
               case "Plants":
                    child.material = this.plantsMaterial;
                    break;
                case "Doors_Desks":
                    child.material = this.doorsMaterial;
                    break;     
                case "Racks_Postes":
                    child.material = this.racksMaterial;
                    break;     
                case "Computers":
                    child.material = this.computersMaterial;
                    break;     
                case "Clouds":
                    child.material = this.cloudsMaterial;
                    break; 
                case "World":
                    child.material = this.worldMaterial;
                    break;
            }        
        })
        this.modelB.traverse((child)=>
        {
            child.material = this.sectorMaterial;              
        })
        //console.log(counter);
        this.modelA.position.x = 18;
        this.modelB.position.x = 18;
        this.modelA.position.y = 0.2;
        this.modelB.position.y = 0.2;
        /*this.modelA.rotateY(MathUtils.degToRad(0))
        this.modelB.rotateY(MathUtils.degToRad(0))*/
        this.scene.add(this.modelA);
        this.scene.add(this.modelB);
    }
    unload()
    {
        this.modelA.position.x = 0;
        this.modelB.position.x = 0;
        this.modelA.position.y = 0;
        this.modelB.position.y = 0;
        this.modelA.rotateY(MathUtils.degToRad(0))
        this.modelB.rotateY(MathUtils.degToRad(0))
    }
    update()
    {        
    }
}